import axios from '@/services/apiAxios';
// import axios from '@/utils/axiosDocker';

export default {
    namespaced: true,
    actions: {
        fetchDpk({ dispatch, rootState }) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `journal/dpk`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                }
                );
            })
        }

    }
}